// extracted by mini-css-extract-plugin
export var root = "SocialLink-module--root--3WAa8";
export var arrow = "SocialLink-module--arrow--1oPgq";
export var small = "SocialLink-module--small--21Zpk";